<template>
  <div class="formLoaderWrapper">
    <div id="loaderComp"></div>
  </div>
  <FormResult v-if="showResult === true" />
  <FormResult v-if="showResult === false" />
</template>

<script>
import lottie from 'lottie-web';
import animationData from '@/assets/dataWhite.json';
import FormResult from './components/FormResult.vue';

import { mapState } from 'vuex';
export default {
  components: {
    FormResult
  },
  computed: mapState(['showResult']),
  mounted() {
    setTimeout(() => {
      document.querySelector('.formLoaderWrapper').classList.toggle('active');
    }, 1);
  }
};
</script>

<style lang="scss" scoped>
.formLoaderWrapper {
  font-size: 1vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 15rem;
  height: 15rem;
  bottom: -300px;
  left: 50%;
  transform: translateX(-50%);
}
.formLoaderWrapper.active {
  bottom: 30px;
  transition: 1.3s;
}
@media screen and (max-width: 768px) {
  .formLoaderWrapper {
    width: 35rem;
    height: 35rem;
  }
}
</style>
